export default {
  text: 'Bei Online Bestellung bitten wir dich online zu zahlen. Die Zahlung kann jederzeit während oder nach dem Essen erfolgen. 😊 *Barzahlung nur möglich, wenn du an der Kasse bestellst.',
  buttons: {
    got_it: 'Alles klar 👍',
  },
};
